import React from 'react';
import { ReactComponent as Icon } from '../../../../../assets/icons/monCompte/unarchive.svg';

function Unarchive({ width = '36px', color = 'var(--grey)', className = '', onClick }) {
  return (
    <Icon
      style={{ '--color': color, 'stroke': 'var(--color)', 'cursor': onClick ? 'pointer' : 'auto' }}
      width={width}
      height={width}
      className={className + (onClick ? ' clickable-icon' : '')}
      onClick={onClick}
    />
  );
}

export default Unarchive;
